/* eslint-disable require-jsdoc */
/* eslint-disable no-undef */
import http from '../../services/http';
import {EventPopUp} from '../popUp/eventPopUp';
import {getMonth} from '../../utils/date';
import {getWindowVenueHtml} from './infoWindowLogic';
import $ from 'jquery';
import { eventTimeConversion } from '../../../../utils/date';
import { debug } from '../../../../config';

import { pApiBase } from '../../../../config';
import { isValid } from '../../utils/validate';

export class InfoWindow {
  constructor(marker, venue, map) {
    this.marker = marker;
    this.venue = venue;
    this.map = map;
    this.infoWindow = undefined;
    this.EventWindow = undefined;
    InfoWindow.get_venueGuid = venue.venueGuid;
  }
  createInfoWindow() {
    if (this.infoWindow) {
      this.infoWindow.close();
    }


    this.infoWindow = new google.maps.InfoWindow({
      content: '',
    });
    google.maps.event.addListener(this.infoWindow, 'domready', function() {
      $(".hearby-map-event-time > a").on('click', function(e) {
        e.preventDefault();
        window.PopUp.popUpEvent(this, e);
           debug && console.log(' infowindow 4 clicked');
          
      });
  });
    if (this.infoWindow) {
      const mapInfoWindowImageLoaded = document.querySelector('div.map-ei-1');
      debug && console.log('this.infoWindow: ', mapInfoWindowImageLoaded);
    }
    if (this.venue.hasEvents == 0) {
      const venueArgs = '?venue_guid=' + this.venue.venueGuid;
      const active = false;
      const infoWindowQueryBase = `${pApiBase}/venue-info`;
      const infoWindowQueryStr = infoWindowQueryBase + venueArgs;
      this.setInfowindowContent(infoWindowQueryStr, active);
    } else {
      const active = true;
      const dateArgs = 'date=' + this.venue.date;
      const venueArgs = '&venue_guid=' + this.venue.venueGuid;
      const infoWindowQueryBase =
        `${pApiBase}/info-window-events?`;
      const infoWindowQueryStr = infoWindowQueryBase + dateArgs + venueArgs;
      this.setInfowindowContent(infoWindowQueryStr, active);
    }

    this.infoWindow.open(this.map, this.marker);
    if (document.querySelector('.event_popup')) {
      debug && console.log('global pop up init1');
      debug && console.log(global.PopUp);
      debug && console.log(window.PopUp);

      window.PopUp.loadClickEvent(window.PopUp);
    }
  }
  setInfowindowContent(infowindow_query_str, active) {
    debug && console.log(infowindow_query_str);
    http.get(infowindow_query_str).then((events) => {
      let content_string = '';
      if (active == true) {
        content_string = this.getInfoWindowEvent(events);
      } else {
        content_string = this.getInfoWindowVenueHtml(events.results[0]);
      }

      this.infoWindow.setContent(content_string);
    });
  }

  getInfoWindowVenueHtml(venue) {
    return getWindowVenueHtml(venue);
  }
  getInfoWindowEvent(events) {
    const first_index = 0;
    const last_index = events.results.length - 1;
    let infowindow_content = '';
    let event_img_buffer = '';
    let event_img_counter = 0;

    for (let index = 0; index < events.results.length; index++) {
      const event = events.results[index].event;
      if (index == first_index) {
        infowindow_content += `<div class = 'hearby-map-venue'><div class='hearby-map-venue-name'>${events.results[index].venue.venueName}</div><div class = 'hearby-map-venue-events'>`;
        const addressArea = `<span class = 'hearby-map-venue-address'>${events.results[index].venue.address}</span>`;
        infowindow_content += addressArea;
        infowindow_content += this.make_infowindow_date(
          events.results[index].event.month,
          events.results[index].event.day,
          events.results[index].event.year,
        );
      }
      infowindow_content += this.create_event_time(event);
      event_img_counter += 1;
      event_img_buffer += this.create_event_img(
          event_img_counter,
          event.eventImage,
      );
      if (index == last_index) {
        infowindow_content += '</div>';
        infowindow_content += `<div class='hearby-map-event-image map-event-images-${event_img_counter.toString()}'>`;
        infowindow_content += event_img_buffer;
        infowindow_content += '</div>';
        infowindow_content += '</div>';
      }
    }
    // create_event_PopUp(events);
    return infowindow_content;
  }
  make_infowindow_date(month, day, year) {
    const month_str = getMonth(month);
    const day_str = day.toString();
    const year_str = year.toString();
    return `<div class = 'hearby-map-date'>${month_str} ${day_str}, ${year_str}</div>`;
  }

  create_event_time(event) {
    const query_str =
      `${pApiBase}/event-detail-tile?eventGuid=` + event.eventGuid;
    const eventPopUp = new EventPopUp();
    debug && console.log('event pop up init2');
    // eventPopUp.init()
    eventPopUp.eventId = $(this).attr('eventGuid');
    eventPopUp.dist = $(this).attr('event-dist');
    const default_img = $(this)
        .parent()
        .parent()
        .parent()
        .parent()
        .parent()
        .parent()
        .parent()
        .attr('default-img');
    if (default_img !== undefined) {
      eventPopUp.defaultImg = default_img;
    } else {
      eventPopUp.defaultImg = '';
    }
    if(String(event.datetimeLocal).split(' ')[4]==='00:00:00' || 
       isValid(event.datetimeUTC)===false){
      return `<div class ='hearby-map-event-time'><a href="javascript:void(0)" event-id="${event.eventGuid}" event-dist="None" class ='event-detail-map'>
      <span class = 'hearby-map-event'>${event.eventName}</span></a></div>`;      
    }
    else {
      return `<div class ='hearby-map-event-time'><a href="javascript:void(0)"  event-id="${event.eventGuid}" event-dist="None" class ='event-detail-map'>
      <span class = 'hearby-map-time'>${eventTimeConversion(event.datetimeUTC)}</span><span class = 'hearby-map-event'>${event.eventName}</span></a></div>`;   
    }
  }

  create_event_img(counter, eventImage) {
    let img_html = '';
    if (eventImage === ''|| eventImage === 'None' || eventImage ===null) {
      img_html = '';
    } else {
      img_html = `<img src= "${eventImage}"onerror="this.style.display='none'">`;
    }
    return `<div class='hearby-map-ei map-ei-${counter.toString()}'>${img_html}</div>`;
  }
}
